import { render, staticRenderFns } from "./MediaFiles.vue?vue&type=template&id=289d013f&"
import script from "./MediaFiles.vue?vue&type=script&lang=js&"
export * from "./MediaFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('289d013f')) {
      api.createRecord('289d013f', component.options)
    } else {
      api.reload('289d013f', component.options)
    }
    module.hot.accept("./MediaFiles.vue?vue&type=template&id=289d013f&", function () {
      api.rerender('289d013f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Wizard/StepTwo/StarterSite/MediaFiles.vue"
export default component.exports